import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { staticRoutes } from '@atlas/routing';

const useSignInRedirects = () => {
  const history = useHistory();

  const redirectToSignIn = useCallback(
    (data, returnLocation = history.location) => {
      history.push(staticRoutes.signin, { data, prevLocation: returnLocation });
    },
    [history],
  );

  const redirectAfterSignIn = useCallback(() => {
    const { pathname = '', search = '' } = history.location.state?.prevLocation || {};
    const data = history.location.state?.data;

    history.replace(`${pathname}${search}` || '/', data);
  }, [history]);

  return { redirectAfterSignIn, redirectToSignIn };
};

export default useSignInRedirects;
